import { FormSelectField } from "@/components/form/FormSelectField";
import type { SelectOption } from "@/components/ui/SelectInput";
import type { SeverityId } from "../hooks/useFeedbackForm";

export const SEVERITY_OPTIONS = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" },
] satisfies SelectOption<SeverityId>[];

interface FeedbackSeverityFieldProps {
  name: string;
  label?: string;
}

export function FeedbackSeverityField({
  name,
  label = "severity",
}: FeedbackSeverityFieldProps) {
  return (
    <FormSelectField
      name={name}
      label={label}
      optional
      options={SEVERITY_OPTIONS}
      placeholder="Select severity"
      data-testid="feedback-severity-select"
    />
  );
}
